/* eslint-disable */
export const asset = {
    "icon": {
        "brand": {
            "appIconMittwald": "assets/icons/Mittwald.svg",
            "appIconM": "assets/icons/Mittwald-M.svg",
            "appIconMChristmas": "assets/icons/Mittwald-M-Christmas.svg",
            "appIconMStudio": "assets/icons/mStudio.svg"
        }
    },
    "font": {
        "base": {
            "Roboto": {
                "ttf": "assets/fonts/Roboto-Regular.ttf"
            },
            "RobotoMono": {
                "ttf": "assets/fonts/RobotoMono-Regular.ttf"
            }
        },
        "brand": {
            "Inter": {
                "woff": {
                    "regular": "assets/fonts/Inter-Regular.woff",
                    "bold": "assets/fonts/Inter-Bold.woff"
                }
            },
            "ProximaNova": {
                "woff": "assets/fonts/proximanova-bold-webfont.woff"
            }
        }
    }
};
export const color = {
    "background": {
        "light": "#ededed",
        "default": "#dadada",
        "dark": "#c6c6c6",
        "darker": "#b2b2b2",
        "disabled": "#706f6f",
        "gradient": {
            "from": "#dadada",
            "to": "#fcfcfc"
        },
        "button": {
            "continue": {
                "default": "#0054f5",
                "hover": "#003fb8",
                "active": "#002a7b",
                "disabled": "#e7effa"
            },
            "complete": {
                "default": "#00a674",
                "hover": "#007d57",
                "active": "#00533a",
                "disabled": "#dbf2eb"
            },
            "destructive": {
                "default": "#e1244c",
                "hover": "#a91b39",
                "active": "#711226",
                "disabled": "#fce1e3"
            },
            "cancel": {
                "default": "#dadada",
                "hover": "#c6c6c6",
                "active": "#b2b2b2",
                "disabled": "#ededed"
            }
        },
        "input": {
            "default": "#ededed",
            "hovered": "#dadada",
            "disabled": "#dadada",
            "focused": "#ffffff",
            "autofill": "#dae7ff",
            "error": "#fce1e3"
        },
        "selectableBox": {
            "default": "#ffffff",
            "hovered": "#f0f4fc",
            "disabled": "#dadada",
            "selected": "#e7effa",
            "selectedDisabled": "#c6c6c6"
        }
    },
    "base": {
        "espelkampGreen": {
            "$10": "#f1fdfa",
            "$25": "#dbf2eb",
            "$50": "#80e3ca",
            "$100": "#00c795",
            "$200": "#00b785",
            "$300": "#00a674",
            "$600": "#007d57",
            "$900": "#00533a"
        },
        "mittwaldNavy": {
            "$50": "#c9cdde",
            "$100": "#939bbd",
            "$200": "#5d689c",
            "$300": "#27367b",
            "$600": "#1d295c",
            "$900": "#141b3e"
        },
        "hostingBlue": {
            "$10": "#f0f4fc",
            "$25": "#e7effa",
            "$50": "#bfd4fd",
            "$100": "#80aafa",
            "$200": "#407ff8",
            "$300": "#0054f5",
            "$600": "#003fb8",
            "$900": "#002a7b"
        },
        "royalOrange": {
            "$10": "#fff9f1",
            "$25": "#feefe3",
            "$50": "#ffe4d0",
            "$100": "#ffc9a1",
            "$200": "#ffae72",
            "$300": "#ff9343",
            "$600": "#d4573e",
            "$900": "#bf393c"
        },
        "amaranthRed": {
            "$10": "#fef3f4",
            "$25": "#fce1e3",
            "$50": "#f8c8d2",
            "$100": "#f092a6",
            "$200": "#e95b79",
            "$300": "#e1244c",
            "$600": "#a91b39",
            "$900": "#711226"
        },
        "softContrastViolet": {
            "$25": "#eeecff",
            "$50": "#dbd7f8",
            "$100": "#b8aef7",
            "$200": "#9485f2",
            "$300": "#715dee",
            "$600": "#5c50ca",
            "$900": "#4743a5"
        },
        "brightLilac": {
            "$50": "#ddd2f9",
            "$100": "#debbfb",
            "$200": "#dfa4fd",
            "$300": "#e08dff",
            "$600": "#cf61f8",
            "$900": "#b155d3"
        },
        "superTeal": {
            "$50": "#a5d7e7",
            "$100": "#6ec5d6",
            "$200": "#37b3c6",
            "$300": "#00a1b5",
            "$600": "#01899a",
            "$900": "#006f7d"
        },
        "grey": {
            "$25": "#ededed",
            "$50": "#dadada",
            "$100": "#c6c6c6",
            "$200": "#b2b2b2",
            "$300": "#878787",
            "$600": "#706f6f",
            "$900": "#3c3c3b"
        },
        "transparent": "rgba(0, 0, 0, 0)",
        "white": "#ffffff",
        "black": "#000000"
    },
    "border": {
        "horizontalRuler": {
            "default": "#c6c6c6"
        },
        "row": {
            "default": "#dadada",
            "selected": "#407ff8"
        },
        "input": {
            "default": "#ededed",
            "focused": "#0054f5",
            "hovered": "#c6c6c6",
            "disabled": "#c6c6c6",
            "error": "#e1244c"
        },
        "selectableBox": {
            "default": "#b2b2b2",
            "selected": "#0054f5"
        }
    },
    "brand": {
        "primary": {
            "lighter": "#939bbd",
            "light": "#5d689c",
            "default": "#27367b",
            "dark": "#1d295c",
            "darker": "#141b3e"
        },
        "secondary": {
            "backgroundLighter": "#f1fdfa",
            "backgroundLight": "#dbf2eb",
            "backgroundDark": "#80e3ca",
            "light": "#00c795",
            "default": "#00a674",
            "dark": "#007d57",
            "darker": "#00533a"
        },
        "highlight": {
            "backgroundLight": "#eeecff",
            "backgroundDark": "#dbd7f8",
            "light": "#b8aef7",
            "default": "#715dee",
            "dark": "#5c50ca",
            "darker": "#4743a5"
        }
    },
    "categorical": {
        "seaGreen": "#0fb5ae",
        "palatinateBlue": "#4046ca",
        "tangerine": "#f68511",
        "magenta": "#de3d82",
        "tropicalIndigo": "#7e84fa",
        "malachite": "#72e06a",
        "azure": "#147af3",
        "violet": "#7326d3",
        "yellow": "#e8c600",
        "alloyOrange": "#cb5d00",
        "green": "#008f5d",
        "lime": "#bce931"
    },
    "font": {
        "text": {
            "default": "#3c3c3b",
            "error": "#e1244c",
            "disabled": "#b2b2b2",
            "inverse": {
                "default": "#ffffff"
            }
        },
        "link": {
            "default": "#0054f5",
            "hover": "#003fb8",
            "active": "#002a7b",
            "disabled": "#bfd4fd",
            "inverse": {
                "default": "#ffffff"
            }
        },
        "destructiveLink": {
            "default": "#e1244c",
            "hover": "#a91b39",
            "active": "#711226",
            "disabled": "#f8c8d2",
            "inverse": {
                "default": "#ffffff"
            }
        },
        "headline": {
            "default": "#27367b",
            "inverse": {
                "default": "#ffffff"
            }
        },
        "label": {
            "default": "#878787"
        },
        "button": {
            "link": {
                "default": "#0054f5",
                "hover": "#003fb8",
                "active": "#002a7b",
                "disabled": "#bfd4fd"
            },
            "continue": {
                "default": "#ffffff",
                "hover": "#ffffff",
                "active": "#ffffff",
                "disabled": "#ffffff"
            },
            "complete": {
                "default": "#ffffff",
                "hover": "#ffffff",
                "active": "#ffffff",
                "disabled": "#ffffff"
            },
            "destructive": {
                "default": "#ffffff",
                "hover": "#ffffff",
                "active": "#ffffff",
                "disabled": "#ffffff"
            },
            "cancel": {
                "default": "#0054f5",
                "hover": "#0054f5",
                "active": "#003fb8",
                "disabled": "#c6c6c6"
            }
        },
        "input": {
            "default": "#706f6f",
            "placeholder": "#878787",
            "error": "#e1244c",
            "disabled": "#878787"
        }
    },
    "status": {
        "error": {
            "backgroundLighter": "#fef3f4",
            "backgroundLight": "#fce1e3",
            "backgroundDark": "#f8c8d2",
            "lighter": "#f092a6",
            "light": "#e95b79",
            "default": "#e1244c",
            "dark": "#a91b39",
            "darker": "#711226"
        },
        "warning": {
            "backgroundLighter": "#fff9f1",
            "backgroundLight": "#feefe3",
            "backgroundDark": "#ffe4d0",
            "lighter": "#ffc9a1",
            "light": "#ffae72",
            "default": "#ff9343",
            "dark": "#d4573e",
            "darker": "#bf393c"
        },
        "success": {
            "backgroundLighter": "#f1fdfa",
            "backgroundLight": "#dbf2eb",
            "backgroundDark": "#80e3ca",
            "lighter": "#00c795",
            "light": "#00b785",
            "default": "#00a674",
            "dark": "#007d57",
            "darker": "#00533a"
        },
        "info": {
            "backgroundLighter": "#f0f4fc",
            "backgroundLight": "#e7effa",
            "backgroundDark": "#bfd4fd",
            "lighter": "#80aafa",
            "light": "#407ff8",
            "default": "#0054f5",
            "dark": "#003fb8",
            "darker": "#002a7b"
        }
    }
};
export const size = {
    "font": {
        "button": "16px",
        "base": {
            "default": "16px",
            "s": "14px",
            "m": "16px",
            "l": "18px",
            "xl": "23px"
        },
        "text": "16px",
        "smallText": "14px",
        "pageTitle": {
            "default": "32px",
            "compact": "24px"
        },
        "h1": {
            "default": "23px",
            "compact": "22px"
        },
        "h2": "18px",
        "h3": "16px",
        "label": "14px",
        "attributeHeadline": "14px",
        "link": {
            "default": "14px",
            "inline": "16px"
        },
        "codeBlock": "14px"
    },
    "borderRadius": "4px",
    "avatar": {
        "m": "40px",
        "l": "96px",
        "xl": "156px"
    },
    "border": {
        "base": {
            "hairline": "1px",
            "outline": "2px",
            "bold": "4px"
        },
        "horizontalRuler": "1px"
    },
    "lineHeight": {
        "base": {
            "default": "24px",
            "s": "20px",
            "m": "24px",
            "l": "34px"
        },
        "text": {
            "default": "24px",
            "squished": "20px"
        },
        "smallText": {
            "default": "24px",
            "squished": "20px"
        },
        "h1": {
            "default": "34px",
            "compact": "24px"
        },
        "h2": {
            "default": "24px"
        },
        "h3": {
            "default": "24px"
        },
        "label": {
            "default": "20px"
        },
        "attributeHeadline": {
            "default": "20px"
        }
    },
    "iconBox": {
        "s": "16px",
        "m": "24px",
        "xl": "64px"
    },
    "icon": {
        "s": "16px",
        "m": "20px",
        "xl": "64px"
    },
    "boxShadow": {
        "overlay": "32px",
        "content": "8px"
    }
};
export const spacing = {
    "inset": {
        "contentBox": "32px",
        "contentBoxCompact": "16px",
        "none": "0px",
        "xs": "4px",
        "s": "8px",
        "m": "16px",
        "l": "24px",
        "xl": "32px",
        "xxl": "64px"
    },
    "input": {
        "vertical": "8px",
        "horizontal": "16px"
    },
    "base": {
        "none": "0px",
        "xxs": "2px",
        "xs": "4px",
        "s": "8px",
        "m": "16px",
        "l": "24px",
        "xl": "32px",
        "xxl": "64px"
    },
    "insetSquish": {
        "none": {
            "x": "0px",
            "y": "0px"
        },
        "s": {
            "x": "8px",
            "y": "4px"
        },
        "m": {
            "x": "16px",
            "y": "8px"
        },
        "l": {
            "x": "32px",
            "y": "16px"
        },
        "xl": {
            "x": "64px",
            "y": "32px"
        }
    },
    "insetStretch": {
        "none": {
            "x": "0px",
            "y": "0px"
        },
        "s": {
            "x": "8px",
            "y": "12px"
        },
        "m": {
            "x": "16px",
            "y": "24px"
        },
        "l": {
            "x": "24px",
            "y": "32px"
        }
    },
    "boxShadow": {
        "overlay": {
            "y": "16px",
            "x": "0px"
        },
        "content": {
            "y": "4px",
            "x": "0px"
        }
    }
};
export const font = {
    "brand": {
        "sansSerif": {
            "family": "Inter"
        },
        "pageTitle": {
            "family": "ProximaNova"
        },
        "monoSpaced": {
            "family": "RobotoMono"
        }
    }
};
export const opacity = {
    "base": {
        "$20": 0.2,
        "$50": 0.5,
        "$80": 0.8
    },
    "disabled": 0.5,
    "curtain": {
        "default": 0.3
    },
    "boxShadow": {
        "overlay": 0.14,
        "content": 0.1
    }
};
export const misc = {
    "gradient": {
        "degree": {
            "base": 170
        }
    }
};
export const duration = {
    "animation": {
        "fast": 125,
        "moderate": 200,
        "slow": 500
    }
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidmFyaWFibGVzLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vc3JjL3Rva2Vucy90cy92YXJpYWJsZXMudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQ0Esb0JBQW9CO0FBRXBCLE1BQU0sQ0FBQyxNQUFNLEtBQUssR0FBRztJQUNuQixNQUFNLEVBQUU7UUFDTixPQUFPLEVBQUU7WUFDUCxpQkFBaUIsRUFBRSwyQkFBMkI7WUFDOUMsVUFBVSxFQUFFLDZCQUE2QjtZQUN6QyxtQkFBbUIsRUFBRSx1Q0FBdUM7WUFDNUQsZ0JBQWdCLEVBQUUsMEJBQTBCO1NBQzdDO0tBQ0Y7SUFDRCxNQUFNLEVBQUU7UUFDTixNQUFNLEVBQUU7WUFDTixRQUFRLEVBQUU7Z0JBQ1IsS0FBSyxFQUFFLGlDQUFpQzthQUN6QztZQUNELFlBQVksRUFBRTtnQkFDWixLQUFLLEVBQUUscUNBQXFDO2FBQzdDO1NBQ0Y7UUFDRCxPQUFPLEVBQUU7WUFDUCxPQUFPLEVBQUU7Z0JBQ1AsTUFBTSxFQUFFO29CQUNOLFNBQVMsRUFBRSxpQ0FBaUM7b0JBQzVDLE1BQU0sRUFBRSw4QkFBOEI7aUJBQ3ZDO2FBQ0Y7WUFDRCxhQUFhLEVBQUU7Z0JBQ2IsTUFBTSxFQUFFLDRDQUE0QzthQUNyRDtTQUNGO0tBQ0Y7Q0FDRixDQUFDO0FBR0YsTUFBTSxDQUFDLE1BQU0sS0FBSyxHQUFHO0lBQ25CLFlBQVksRUFBRTtRQUNaLE9BQU8sRUFBRSxTQUFTO1FBQ2xCLFNBQVMsRUFBRSxTQUFTO1FBQ3BCLE1BQU0sRUFBRSxTQUFTO1FBQ2pCLFFBQVEsRUFBRSxTQUFTO1FBQ25CLFVBQVUsRUFBRSxTQUFTO1FBQ3JCLFVBQVUsRUFBRTtZQUNWLE1BQU0sRUFBRSxTQUFTO1lBQ2pCLElBQUksRUFBRSxTQUFTO1NBQ2hCO1FBQ0QsUUFBUSxFQUFFO1lBQ1IsVUFBVSxFQUFFO2dCQUNWLFNBQVMsRUFBRSxTQUFTO2dCQUNwQixPQUFPLEVBQUUsU0FBUztnQkFDbEIsUUFBUSxFQUFFLFNBQVM7Z0JBQ25CLFVBQVUsRUFBRSxTQUFTO2FBQ3RCO1lBQ0QsVUFBVSxFQUFFO2dCQUNWLFNBQVMsRUFBRSxTQUFTO2dCQUNwQixPQUFPLEVBQUUsU0FBUztnQkFDbEIsUUFBUSxFQUFFLFNBQVM7Z0JBQ25CLFVBQVUsRUFBRSxTQUFTO2FBQ3RCO1lBQ0QsYUFBYSxFQUFFO2dCQUNiLFNBQVMsRUFBRSxTQUFTO2dCQUNwQixPQUFPLEVBQUUsU0FBUztnQkFDbEIsUUFBUSxFQUFFLFNBQVM7Z0JBQ25CLFVBQVUsRUFBRSxTQUFTO2FBQ3RCO1lBQ0QsUUFBUSxFQUFFO2dCQUNSLFNBQVMsRUFBRSxTQUFTO2dCQUNwQixPQUFPLEVBQUUsU0FBUztnQkFDbEIsUUFBUSxFQUFFLFNBQVM7Z0JBQ25CLFVBQVUsRUFBRSxTQUFTO2FBQ3RCO1NBQ0Y7UUFDRCxPQUFPLEVBQUU7WUFDUCxTQUFTLEVBQUUsU0FBUztZQUNwQixTQUFTLEVBQUUsU0FBUztZQUNwQixVQUFVLEVBQUUsU0FBUztZQUNyQixTQUFTLEVBQUUsU0FBUztZQUNwQixVQUFVLEVBQUUsU0FBUztZQUNyQixPQUFPLEVBQUUsU0FBUztTQUNuQjtRQUNELGVBQWUsRUFBRTtZQUNmLFNBQVMsRUFBRSxTQUFTO1lBQ3BCLFNBQVMsRUFBRSxTQUFTO1lBQ3BCLFVBQVUsRUFBRSxTQUFTO1lBQ3JCLFVBQVUsRUFBRSxTQUFTO1lBQ3JCLGtCQUFrQixFQUFFLFNBQVM7U0FDOUI7S0FDRjtJQUNELE1BQU0sRUFBRTtRQUNOLGdCQUFnQixFQUFFO1lBQ2hCLEtBQUssRUFBRSxTQUFTO1lBQ2hCLEtBQUssRUFBRSxTQUFTO1lBQ2hCLEtBQUssRUFBRSxTQUFTO1lBQ2hCLE1BQU0sRUFBRSxTQUFTO1lBQ2pCLE1BQU0sRUFBRSxTQUFTO1lBQ2pCLE1BQU0sRUFBRSxTQUFTO1lBQ2pCLE1BQU0sRUFBRSxTQUFTO1lBQ2pCLE1BQU0sRUFBRSxTQUFTO1NBQ2xCO1FBQ0QsY0FBYyxFQUFFO1lBQ2QsS0FBSyxFQUFFLFNBQVM7WUFDaEIsTUFBTSxFQUFFLFNBQVM7WUFDakIsTUFBTSxFQUFFLFNBQVM7WUFDakIsTUFBTSxFQUFFLFNBQVM7WUFDakIsTUFBTSxFQUFFLFNBQVM7WUFDakIsTUFBTSxFQUFFLFNBQVM7U0FDbEI7UUFDRCxhQUFhLEVBQUU7WUFDYixLQUFLLEVBQUUsU0FBUztZQUNoQixLQUFLLEVBQUUsU0FBUztZQUNoQixLQUFLLEVBQUUsU0FBUztZQUNoQixNQUFNLEVBQUUsU0FBUztZQUNqQixNQUFNLEVBQUUsU0FBUztZQUNqQixNQUFNLEVBQUUsU0FBUztZQUNqQixNQUFNLEVBQUUsU0FBUztZQUNqQixNQUFNLEVBQUUsU0FBUztTQUNsQjtRQUNELGFBQWEsRUFBRTtZQUNiLEtBQUssRUFBRSxTQUFTO1lBQ2hCLEtBQUssRUFBRSxTQUFTO1lBQ2hCLEtBQUssRUFBRSxTQUFTO1lBQ2hCLE1BQU0sRUFBRSxTQUFTO1lBQ2pCLE1BQU0sRUFBRSxTQUFTO1lBQ2pCLE1BQU0sRUFBRSxTQUFTO1lBQ2pCLE1BQU0sRUFBRSxTQUFTO1lBQ2pCLE1BQU0sRUFBRSxTQUFTO1NBQ2xCO1FBQ0QsYUFBYSxFQUFFO1lBQ2IsS0FBSyxFQUFFLFNBQVM7WUFDaEIsS0FBSyxFQUFFLFNBQVM7WUFDaEIsS0FBSyxFQUFFLFNBQVM7WUFDaEIsTUFBTSxFQUFFLFNBQVM7WUFDakIsTUFBTSxFQUFFLFNBQVM7WUFDakIsTUFBTSxFQUFFLFNBQVM7WUFDakIsTUFBTSxFQUFFLFNBQVM7WUFDakIsTUFBTSxFQUFFLFNBQVM7U0FDbEI7UUFDRCxvQkFBb0IsRUFBRTtZQUNwQixLQUFLLEVBQUUsU0FBUztZQUNoQixLQUFLLEVBQUUsU0FBUztZQUNoQixNQUFNLEVBQUUsU0FBUztZQUNqQixNQUFNLEVBQUUsU0FBUztZQUNqQixNQUFNLEVBQUUsU0FBUztZQUNqQixNQUFNLEVBQUUsU0FBUztZQUNqQixNQUFNLEVBQUUsU0FBUztTQUNsQjtRQUNELGFBQWEsRUFBRTtZQUNiLEtBQUssRUFBRSxTQUFTO1lBQ2hCLE1BQU0sRUFBRSxTQUFTO1lBQ2pCLE1BQU0sRUFBRSxTQUFTO1lBQ2pCLE1BQU0sRUFBRSxTQUFTO1lBQ2pCLE1BQU0sRUFBRSxTQUFTO1lBQ2pCLE1BQU0sRUFBRSxTQUFTO1NBQ2xCO1FBQ0QsV0FBVyxFQUFFO1lBQ1gsS0FBSyxFQUFFLFNBQVM7WUFDaEIsTUFBTSxFQUFFLFNBQVM7WUFDakIsTUFBTSxFQUFFLFNBQVM7WUFDakIsTUFBTSxFQUFFLFNBQVM7WUFDakIsTUFBTSxFQUFFLFNBQVM7WUFDakIsTUFBTSxFQUFFLFNBQVM7U0FDbEI7UUFDRCxNQUFNLEVBQUU7WUFDTixLQUFLLEVBQUUsU0FBUztZQUNoQixLQUFLLEVBQUUsU0FBUztZQUNoQixNQUFNLEVBQUUsU0FBUztZQUNqQixNQUFNLEVBQUUsU0FBUztZQUNqQixNQUFNLEVBQUUsU0FBUztZQUNqQixNQUFNLEVBQUUsU0FBUztZQUNqQixNQUFNLEVBQUUsU0FBUztTQUNsQjtRQUNELGFBQWEsRUFBRSxrQkFBa0I7UUFDakMsT0FBTyxFQUFFLFNBQVM7UUFDbEIsT0FBTyxFQUFFLFNBQVM7S0FDbkI7SUFDRCxRQUFRLEVBQUU7UUFDUixpQkFBaUIsRUFBRTtZQUNqQixTQUFTLEVBQUUsU0FBUztTQUNyQjtRQUNELEtBQUssRUFBRTtZQUNMLFNBQVMsRUFBRSxTQUFTO1lBQ3BCLFVBQVUsRUFBRSxTQUFTO1NBQ3RCO1FBQ0QsT0FBTyxFQUFFO1lBQ1AsU0FBUyxFQUFFLFNBQVM7WUFDcEIsU0FBUyxFQUFFLFNBQVM7WUFDcEIsU0FBUyxFQUFFLFNBQVM7WUFDcEIsVUFBVSxFQUFFLFNBQVM7WUFDckIsT0FBTyxFQUFFLFNBQVM7U0FDbkI7UUFDRCxlQUFlLEVBQUU7WUFDZixTQUFTLEVBQUUsU0FBUztZQUNwQixVQUFVLEVBQUUsU0FBUztTQUN0QjtLQUNGO0lBQ0QsT0FBTyxFQUFFO1FBQ1AsU0FBUyxFQUFFO1lBQ1QsU0FBUyxFQUFFLFNBQVM7WUFDcEIsT0FBTyxFQUFFLFNBQVM7WUFDbEIsU0FBUyxFQUFFLFNBQVM7WUFDcEIsTUFBTSxFQUFFLFNBQVM7WUFDakIsUUFBUSxFQUFFLFNBQVM7U0FDcEI7UUFDRCxXQUFXLEVBQUU7WUFDWCxtQkFBbUIsRUFBRSxTQUFTO1lBQzlCLGlCQUFpQixFQUFFLFNBQVM7WUFDNUIsZ0JBQWdCLEVBQUUsU0FBUztZQUMzQixPQUFPLEVBQUUsU0FBUztZQUNsQixTQUFTLEVBQUUsU0FBUztZQUNwQixNQUFNLEVBQUUsU0FBUztZQUNqQixRQUFRLEVBQUUsU0FBUztTQUNwQjtRQUNELFdBQVcsRUFBRTtZQUNYLGlCQUFpQixFQUFFLFNBQVM7WUFDNUIsZ0JBQWdCLEVBQUUsU0FBUztZQUMzQixPQUFPLEVBQUUsU0FBUztZQUNsQixTQUFTLEVBQUUsU0FBUztZQUNwQixNQUFNLEVBQUUsU0FBUztZQUNqQixRQUFRLEVBQUUsU0FBUztTQUNwQjtLQUNGO0lBQ0QsYUFBYSxFQUFFO1FBQ2IsVUFBVSxFQUFFLFNBQVM7UUFDckIsZ0JBQWdCLEVBQUUsU0FBUztRQUMzQixXQUFXLEVBQUUsU0FBUztRQUN0QixTQUFTLEVBQUUsU0FBUztRQUNwQixnQkFBZ0IsRUFBRSxTQUFTO1FBQzNCLFdBQVcsRUFBRSxTQUFTO1FBQ3RCLE9BQU8sRUFBRSxTQUFTO1FBQ2xCLFFBQVEsRUFBRSxTQUFTO1FBQ25CLFFBQVEsRUFBRSxTQUFTO1FBQ25CLGFBQWEsRUFBRSxTQUFTO1FBQ3hCLE9BQU8sRUFBRSxTQUFTO1FBQ2xCLE1BQU0sRUFBRSxTQUFTO0tBQ2xCO0lBQ0QsTUFBTSxFQUFFO1FBQ04sTUFBTSxFQUFFO1lBQ04sU0FBUyxFQUFFLFNBQVM7WUFDcEIsT0FBTyxFQUFFLFNBQVM7WUFDbEIsVUFBVSxFQUFFLFNBQVM7WUFDckIsU0FBUyxFQUFFO2dCQUNULFNBQVMsRUFBRSxTQUFTO2FBQ3JCO1NBQ0Y7UUFDRCxNQUFNLEVBQUU7WUFDTixTQUFTLEVBQUUsU0FBUztZQUNwQixPQUFPLEVBQUUsU0FBUztZQUNsQixRQUFRLEVBQUUsU0FBUztZQUNuQixVQUFVLEVBQUUsU0FBUztZQUNyQixTQUFTLEVBQUU7Z0JBQ1QsU0FBUyxFQUFFLFNBQVM7YUFDckI7U0FDRjtRQUNELGlCQUFpQixFQUFFO1lBQ2pCLFNBQVMsRUFBRSxTQUFTO1lBQ3BCLE9BQU8sRUFBRSxTQUFTO1lBQ2xCLFFBQVEsRUFBRSxTQUFTO1lBQ25CLFVBQVUsRUFBRSxTQUFTO1lBQ3JCLFNBQVMsRUFBRTtnQkFDVCxTQUFTLEVBQUUsU0FBUzthQUNyQjtTQUNGO1FBQ0QsVUFBVSxFQUFFO1lBQ1YsU0FBUyxFQUFFLFNBQVM7WUFDcEIsU0FBUyxFQUFFO2dCQUNULFNBQVMsRUFBRSxTQUFTO2FBQ3JCO1NBQ0Y7UUFDRCxPQUFPLEVBQUU7WUFDUCxTQUFTLEVBQUUsU0FBUztTQUNyQjtRQUNELFFBQVEsRUFBRTtZQUNSLE1BQU0sRUFBRTtnQkFDTixTQUFTLEVBQUUsU0FBUztnQkFDcEIsT0FBTyxFQUFFLFNBQVM7Z0JBQ2xCLFFBQVEsRUFBRSxTQUFTO2dCQUNuQixVQUFVLEVBQUUsU0FBUzthQUN0QjtZQUNELFVBQVUsRUFBRTtnQkFDVixTQUFTLEVBQUUsU0FBUztnQkFDcEIsT0FBTyxFQUFFLFNBQVM7Z0JBQ2xCLFFBQVEsRUFBRSxTQUFTO2dCQUNuQixVQUFVLEVBQUUsU0FBUzthQUN0QjtZQUNELFVBQVUsRUFBRTtnQkFDVixTQUFTLEVBQUUsU0FBUztnQkFDcEIsT0FBTyxFQUFFLFNBQVM7Z0JBQ2xCLFFBQVEsRUFBRSxTQUFTO2dCQUNuQixVQUFVLEVBQUUsU0FBUzthQUN0QjtZQUNELGFBQWEsRUFBRTtnQkFDYixTQUFTLEVBQUUsU0FBUztnQkFDcEIsT0FBTyxFQUFFLFNBQVM7Z0JBQ2xCLFFBQVEsRUFBRSxTQUFTO2dCQUNuQixVQUFVLEVBQUUsU0FBUzthQUN0QjtZQUNELFFBQVEsRUFBRTtnQkFDUixTQUFTLEVBQUUsU0FBUztnQkFDcEIsT0FBTyxFQUFFLFNBQVM7Z0JBQ2xCLFFBQVEsRUFBRSxTQUFTO2dCQUNuQixVQUFVLEVBQUUsU0FBUzthQUN0QjtTQUNGO1FBQ0QsT0FBTyxFQUFFO1lBQ1AsU0FBUyxFQUFFLFNBQVM7WUFDcEIsYUFBYSxFQUFFLFNBQVM7WUFDeEIsT0FBTyxFQUFFLFNBQVM7WUFDbEIsVUFBVSxFQUFFLFNBQVM7U0FDdEI7S0FDRjtJQUNELFFBQVEsRUFBRTtRQUNSLE9BQU8sRUFBRTtZQUNQLG1CQUFtQixFQUFFLFNBQVM7WUFDOUIsaUJBQWlCLEVBQUUsU0FBUztZQUM1QixnQkFBZ0IsRUFBRSxTQUFTO1lBQzNCLFNBQVMsRUFBRSxTQUFTO1lBQ3BCLE9BQU8sRUFBRSxTQUFTO1lBQ2xCLFNBQVMsRUFBRSxTQUFTO1lBQ3BCLE1BQU0sRUFBRSxTQUFTO1lBQ2pCLFFBQVEsRUFBRSxTQUFTO1NBQ3BCO1FBQ0QsU0FBUyxFQUFFO1lBQ1QsbUJBQW1CLEVBQUUsU0FBUztZQUM5QixpQkFBaUIsRUFBRSxTQUFTO1lBQzVCLGdCQUFnQixFQUFFLFNBQVM7WUFDM0IsU0FBUyxFQUFFLFNBQVM7WUFDcEIsT0FBTyxFQUFFLFNBQVM7WUFDbEIsU0FBUyxFQUFFLFNBQVM7WUFDcEIsTUFBTSxFQUFFLFNBQVM7WUFDakIsUUFBUSxFQUFFLFNBQVM7U0FDcEI7UUFDRCxTQUFTLEVBQUU7WUFDVCxtQkFBbUIsRUFBRSxTQUFTO1lBQzlCLGlCQUFpQixFQUFFLFNBQVM7WUFDNUIsZ0JBQWdCLEVBQUUsU0FBUztZQUMzQixTQUFTLEVBQUUsU0FBUztZQUNwQixPQUFPLEVBQUUsU0FBUztZQUNsQixTQUFTLEVBQUUsU0FBUztZQUNwQixNQUFNLEVBQUUsU0FBUztZQUNqQixRQUFRLEVBQUUsU0FBUztTQUNwQjtRQUNELE1BQU0sRUFBRTtZQUNOLG1CQUFtQixFQUFFLFNBQVM7WUFDOUIsaUJBQWlCLEVBQUUsU0FBUztZQUM1QixnQkFBZ0IsRUFBRSxTQUFTO1lBQzNCLFNBQVMsRUFBRSxTQUFTO1lBQ3BCLE9BQU8sRUFBRSxTQUFTO1lBQ2xCLFNBQVMsRUFBRSxTQUFTO1lBQ3BCLE1BQU0sRUFBRSxTQUFTO1lBQ2pCLFFBQVEsRUFBRSxTQUFTO1NBQ3BCO0tBQ0Y7Q0FDRixDQUFDO0FBR0YsTUFBTSxDQUFDLE1BQU0sSUFBSSxHQUFHO0lBQ2xCLE1BQU0sRUFBRTtRQUNOLFFBQVEsRUFBRSxNQUFNO1FBQ2hCLE1BQU0sRUFBRTtZQUNOLFNBQVMsRUFBRSxNQUFNO1lBQ2pCLEdBQUcsRUFBRSxNQUFNO1lBQ1gsR0FBRyxFQUFFLE1BQU07WUFDWCxHQUFHLEVBQUUsTUFBTTtZQUNYLElBQUksRUFBRSxNQUFNO1NBQ2I7UUFDRCxNQUFNLEVBQUUsTUFBTTtRQUNkLFdBQVcsRUFBRSxNQUFNO1FBQ25CLFdBQVcsRUFBRTtZQUNYLFNBQVMsRUFBRSxNQUFNO1lBQ2pCLFNBQVMsRUFBRSxNQUFNO1NBQ2xCO1FBQ0QsSUFBSSxFQUFFO1lBQ0osU0FBUyxFQUFFLE1BQU07WUFDakIsU0FBUyxFQUFFLE1BQU07U0FDbEI7UUFDRCxJQUFJLEVBQUUsTUFBTTtRQUNaLElBQUksRUFBRSxNQUFNO1FBQ1osT0FBTyxFQUFFLE1BQU07UUFDZixtQkFBbUIsRUFBRSxNQUFNO1FBQzNCLE1BQU0sRUFBRTtZQUNOLFNBQVMsRUFBRSxNQUFNO1lBQ2pCLFFBQVEsRUFBRSxNQUFNO1NBQ2pCO1FBQ0QsV0FBVyxFQUFFLE1BQU07S0FDcEI7SUFDRCxjQUFjLEVBQUUsS0FBSztJQUNyQixRQUFRLEVBQUU7UUFDUixHQUFHLEVBQUUsTUFBTTtRQUNYLEdBQUcsRUFBRSxNQUFNO1FBQ1gsSUFBSSxFQUFFLE9BQU87S0FDZDtJQUNELFFBQVEsRUFBRTtRQUNSLE1BQU0sRUFBRTtZQUNOLFVBQVUsRUFBRSxLQUFLO1lBQ2pCLFNBQVMsRUFBRSxLQUFLO1lBQ2hCLE1BQU0sRUFBRSxLQUFLO1NBQ2Q7UUFDRCxpQkFBaUIsRUFBRSxLQUFLO0tBQ3pCO0lBQ0QsWUFBWSxFQUFFO1FBQ1osTUFBTSxFQUFFO1lBQ04sU0FBUyxFQUFFLE1BQU07WUFDakIsR0FBRyxFQUFFLE1BQU07WUFDWCxHQUFHLEVBQUUsTUFBTTtZQUNYLEdBQUcsRUFBRSxNQUFNO1NBQ1o7UUFDRCxNQUFNLEVBQUU7WUFDTixTQUFTLEVBQUUsTUFBTTtZQUNqQixVQUFVLEVBQUUsTUFBTTtTQUNuQjtRQUNELFdBQVcsRUFBRTtZQUNYLFNBQVMsRUFBRSxNQUFNO1lBQ2pCLFVBQVUsRUFBRSxNQUFNO1NBQ25CO1FBQ0QsSUFBSSxFQUFFO1lBQ0osU0FBUyxFQUFFLE1BQU07WUFDakIsU0FBUyxFQUFFLE1BQU07U0FDbEI7UUFDRCxJQUFJLEVBQUU7WUFDSixTQUFTLEVBQUUsTUFBTTtTQUNsQjtRQUNELElBQUksRUFBRTtZQUNKLFNBQVMsRUFBRSxNQUFNO1NBQ2xCO1FBQ0QsT0FBTyxFQUFFO1lBQ1AsU0FBUyxFQUFFLE1BQU07U0FDbEI7UUFDRCxtQkFBbUIsRUFBRTtZQUNuQixTQUFTLEVBQUUsTUFBTTtTQUNsQjtLQUNGO0lBQ0QsU0FBUyxFQUFFO1FBQ1QsR0FBRyxFQUFFLE1BQU07UUFDWCxHQUFHLEVBQUUsTUFBTTtRQUNYLElBQUksRUFBRSxNQUFNO0tBQ2I7SUFDRCxNQUFNLEVBQUU7UUFDTixHQUFHLEVBQUUsTUFBTTtRQUNYLEdBQUcsRUFBRSxNQUFNO1FBQ1gsSUFBSSxFQUFFLE1BQU07S0FDYjtJQUNELFdBQVcsRUFBRTtRQUNYLFNBQVMsRUFBRSxNQUFNO1FBQ2pCLFNBQVMsRUFBRSxLQUFLO0tBQ2pCO0NBQ0YsQ0FBQztBQUdGLE1BQU0sQ0FBQyxNQUFNLE9BQU8sR0FBRztJQUNyQixPQUFPLEVBQUU7UUFDUCxZQUFZLEVBQUUsTUFBTTtRQUNwQixtQkFBbUIsRUFBRSxNQUFNO1FBQzNCLE1BQU0sRUFBRSxLQUFLO1FBQ2IsSUFBSSxFQUFFLEtBQUs7UUFDWCxHQUFHLEVBQUUsS0FBSztRQUNWLEdBQUcsRUFBRSxNQUFNO1FBQ1gsR0FBRyxFQUFFLE1BQU07UUFDWCxJQUFJLEVBQUUsTUFBTTtRQUNaLEtBQUssRUFBRSxNQUFNO0tBQ2Q7SUFDRCxPQUFPLEVBQUU7UUFDUCxVQUFVLEVBQUUsS0FBSztRQUNqQixZQUFZLEVBQUUsTUFBTTtLQUNyQjtJQUNELE1BQU0sRUFBRTtRQUNOLE1BQU0sRUFBRSxLQUFLO1FBQ2IsS0FBSyxFQUFFLEtBQUs7UUFDWixJQUFJLEVBQUUsS0FBSztRQUNYLEdBQUcsRUFBRSxLQUFLO1FBQ1YsR0FBRyxFQUFFLE1BQU07UUFDWCxHQUFHLEVBQUUsTUFBTTtRQUNYLElBQUksRUFBRSxNQUFNO1FBQ1osS0FBSyxFQUFFLE1BQU07S0FDZDtJQUNELGFBQWEsRUFBRTtRQUNiLE1BQU0sRUFBRTtZQUNOLEdBQUcsRUFBRSxLQUFLO1lBQ1YsR0FBRyxFQUFFLEtBQUs7U0FDWDtRQUNELEdBQUcsRUFBRTtZQUNILEdBQUcsRUFBRSxLQUFLO1lBQ1YsR0FBRyxFQUFFLEtBQUs7U0FDWDtRQUNELEdBQUcsRUFBRTtZQUNILEdBQUcsRUFBRSxNQUFNO1lBQ1gsR0FBRyxFQUFFLEtBQUs7U0FDWDtRQUNELEdBQUcsRUFBRTtZQUNILEdBQUcsRUFBRSxNQUFNO1lBQ1gsR0FBRyxFQUFFLE1BQU07U0FDWjtRQUNELElBQUksRUFBRTtZQUNKLEdBQUcsRUFBRSxNQUFNO1lBQ1gsR0FBRyxFQUFFLE1BQU07U0FDWjtLQUNGO0lBQ0QsY0FBYyxFQUFFO1FBQ2QsTUFBTSxFQUFFO1lBQ04sR0FBRyxFQUFFLEtBQUs7WUFDVixHQUFHLEVBQUUsS0FBSztTQUNYO1FBQ0QsR0FBRyxFQUFFO1lBQ0gsR0FBRyxFQUFFLEtBQUs7WUFDVixHQUFHLEVBQUUsTUFBTTtTQUNaO1FBQ0QsR0FBRyxFQUFFO1lBQ0gsR0FBRyxFQUFFLE1BQU07WUFDWCxHQUFHLEVBQUUsTUFBTTtTQUNaO1FBQ0QsR0FBRyxFQUFFO1lBQ0gsR0FBRyxFQUFFLE1BQU07WUFDWCxHQUFHLEVBQUUsTUFBTTtTQUNaO0tBQ0Y7SUFDRCxXQUFXLEVBQUU7UUFDWCxTQUFTLEVBQUU7WUFDVCxHQUFHLEVBQUUsTUFBTTtZQUNYLEdBQUcsRUFBRSxLQUFLO1NBQ1g7UUFDRCxTQUFTLEVBQUU7WUFDVCxHQUFHLEVBQUUsS0FBSztZQUNWLEdBQUcsRUFBRSxLQUFLO1NBQ1g7S0FDRjtDQUNGLENBQUM7QUFHRixNQUFNLENBQUMsTUFBTSxJQUFJLEdBQUc7SUFDbEIsT0FBTyxFQUFFO1FBQ1AsV0FBVyxFQUFFO1lBQ1gsUUFBUSxFQUFFLE9BQU87U0FDbEI7UUFDRCxXQUFXLEVBQUU7WUFDWCxRQUFRLEVBQUUsYUFBYTtTQUN4QjtRQUNELFlBQVksRUFBRTtZQUNaLFFBQVEsRUFBRSxZQUFZO1NBQ3ZCO0tBQ0Y7Q0FDRixDQUFDO0FBR0YsTUFBTSxDQUFDLE1BQU0sT0FBTyxHQUFHO0lBQ3JCLE1BQU0sRUFBRTtRQUNOLEtBQUssRUFBRSxHQUFHO1FBQ1YsS0FBSyxFQUFFLEdBQUc7UUFDVixLQUFLLEVBQUUsR0FBRztLQUNYO0lBQ0QsVUFBVSxFQUFFLEdBQUc7SUFDZixTQUFTLEVBQUU7UUFDVCxTQUFTLEVBQUUsR0FBRztLQUNmO0lBQ0QsV0FBVyxFQUFFO1FBQ1gsU0FBUyxFQUFFLElBQUk7UUFDZixTQUFTLEVBQUUsR0FBRztLQUNmO0NBQ0YsQ0FBQztBQUdGLE1BQU0sQ0FBQyxNQUFNLElBQUksR0FBRztJQUNsQixVQUFVLEVBQUU7UUFDVixRQUFRLEVBQUU7WUFDUixNQUFNLEVBQUUsR0FBRztTQUNaO0tBQ0Y7Q0FDRixDQUFDO0FBR0YsTUFBTSxDQUFDLE1BQU0sUUFBUSxHQUFHO0lBQ3RCLFdBQVcsRUFBRTtRQUNYLE1BQU0sRUFBRSxHQUFHO1FBQ1gsVUFBVSxFQUFFLEdBQUc7UUFDZixNQUFNLEVBQUUsR0FBRztLQUNaO0NBQ0YsQ0FBQyJ9